var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { ArgumentError, ArgumentErrorType, HttpError, QueryCondition, QUERY_CONDITION_TYPE, Result, isNoResultError, } from '@tencent/tdoc-database';
import { PadIdType, TableName } from '../Constant';
import { DocumentStatus } from '../model/DocumentStatus';
import { SyncResultCode, } from '../model/Interface';
import { OFFLINE_ITEM_TYPE } from '../model/OfflineData';
import { FILE_TYPE, PadInfo, PadStatus, typeMap, } from '../model/PadInfo';
import { CGI, Method } from '../tools/CGI';
import ClientMutexLock from '../tools/ClientMutexLock';
import Log from '../tools/Log';
import MultiTabLock from '../tools/MultiTabLock';
import { checkDebugOffline, getXsrf, isSupportClientDB, logSyncResult, reconstructDocUrl, } from '../tools/utils';
import { backupOfflineData } from '../tools/DataBackup';
import { convertToArkOfflineData } from '../tools/DataConvert';
import { docTextOfInitialAttributedText } from '../tools/doc_keyframe';
export var Lock = isSupportClientDB() && !checkDebugOffline() ? ClientMutexLock : MultiTabLock;
export function createLock(config) {
    return isSupportClientDB() && !checkDebugOffline() ? new ClientMutexLock(config) : new MultiTabLock(config);
}
var DEFAULT_DOC_CODE_VER = '2.1.0';
var DEFAULT_SHEET_CODE_VER = '2.4.0';
var DEFAULT_SLIDE_CODE_VER = '1.0.0';
export var LocalNewMaxNum = 10; //  分别最多预创建10个Word和10个Excel文档数据
var BaseBusinessHelper = /** @class */ (function () {
    function BaseBusinessHelper(options) {
        this.defaultCodeVersion = new Map();
        this.parent = options.parent;
        this.database = options.database;
        this.setDefaultCodeVersion('doc', DEFAULT_DOC_CODE_VER);
        this.setDefaultCodeVersion('sheet', DEFAULT_SHEET_CODE_VER);
        this.setDefaultCodeVersion('slide', DEFAULT_SLIDE_CODE_VER);
    }
    /**
     * 判断给定的globalPadIds中有哪些文档id有本地未提交的离线数据
     * @param globalPadIds
     */
    BaseBusinessHelper.prototype.filterUncommitedPadId = function (globalPadIds) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult, offlineDatas, padIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (globalPadIds && globalPadIds.length === 0) {
                            return [2 /*return*/, new Result(new ArgumentError(ArgumentErrorType.ILLEGAL_ARGUMENT, '文档Id数组长度不能为0'))];
                        }
                        condition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.COMMITING, OFFLINE_ITEM_TYPE.WATTING, OFFLINE_ITEM_TYPE.QUEUE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        if (globalPadIds) {
                            condition.addCondition('globalPadId', QUERY_CONDITION_TYPE.IN, globalPadIds);
                        }
                        return [4 /*yield*/, this.database.getAll(TableName.OFFLINE_DATA, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error) {
                            Log.error('查询失败', queryResult.error);
                            return [2 /*return*/, queryResult];
                        }
                        offlineDatas = queryResult.data;
                        padIds = offlineDatas.map(function (offlineData) { return offlineData.globalPadId; }).reduce(function (prev, cur) { return (prev.includes(cur) ? prev : __spreadArrays(prev, [cur])); }, new Array());
                        return [2 /*return*/, new Result(undefined, padIds)];
                }
            });
        });
    };
    /**
     * 判断给定的文档id中有哪些文档id需要更新本地缓存
     * @param globalPadIds 如果为undefine则对所有文档进行判断
     */
    BaseBusinessHelper.prototype.filterNeedUpdateCachePadId = function (globalPadIds) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult, shreshold, offlineDatas, countMap, padIds, i, offlineData, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (globalPadIds && globalPadIds.length === 0) {
                            return [2 /*return*/, new Result(new ArgumentError(ArgumentErrorType.ILLEGAL_ARGUMENT, '文档Id数组长度不能为0'))];
                        }
                        condition = QueryCondition.newInstance()
                            // .addCondition('type', QUERY_CONDITION_TYPE.NOT_IN, [OFFLINE_ITEM_TYPE.COMMITING, OFFLINE_ITEM_TYPE.WATTING, OFFLINE_ITEM_TYPE.QUEUE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        if (globalPadIds) {
                            condition.addCondition('globalPadId', QUERY_CONDITION_TYPE.IN, globalPadIds);
                        }
                        return [4 /*yield*/, this.database.getAll(TableName.DOCUMENT_DATA, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error) {
                            Log.error('查询失败', queryResult.error);
                            return [2 /*return*/, queryResult];
                        }
                        shreshold = 10;
                        offlineDatas = queryResult.data;
                        countMap = new Map();
                        padIds = new Array();
                        for (i = 0; i < offlineDatas.length; i++) {
                            offlineData = offlineDatas[i];
                            count = countMap.get(offlineData.globalPadId) || 0;
                            countMap.set(offlineData.globalPadId, count + 1); // 加一
                            if (count + 1 === shreshold) { // 满足条件 那就放到目标数组里面去
                                padIds.push(offlineData.globalPadId);
                            }
                        }
                        return [2 /*return*/, new Result(undefined, padIds)];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.getUncommitedOfflineData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.COMMITING, OFFLINE_ITEM_TYPE.WATTING, OFFLINE_ITEM_TYPE.QUEUE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.getAll(TableName.OFFLINE_DATA, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error) {
                            Log.error('查询失败', queryResult.error);
                            return [2 /*return*/, queryResult];
                        }
                        return [2 /*return*/, queryResult];
                }
            });
        });
    };
    /**
     * 同步指定文档离线数据
     * 分四步进行：
     * 1、获取本地未提交离线数据
     * 2、批量提交本地未提交的离线数据
     * 3、更新本地未提交离线数据为已提交数据  （用提交成功后后台返回的misschange来替换本地未提交的离线数据）
     * 4、拉取文档最新的所有子表数据
     * 5、更新文档本地缓存离线数据  （删除原来的所有离线数据并写入最新预拉取的子表数据）
     * @param padId 文档唯一ID
     * @param secretId 文档加密ID URL后面那个
     * @param source 来源 列表页使用'list' 编辑页使用'edit'
     * @param force 是否强制同步 默认false 如果强制同步，则不会进行节流
     * @param padType 文档类型
     */
    BaseBusinessHelper.prototype.syncOfflineData = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var padId, secretId, padType, onCommiting, onCommitFinished, _a, source, _b, force, checkResult, lock, offlineLock, result, createFileResult, commitResult, fetchAndStoreResult, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Log.log('call SyncOfflineData()', options);
                        padId = options.padId, secretId = options.secretId, padType = options.padType, onCommiting = options.onCommiting, onCommitFinished = options.onCommitFinished, _a = options.source, source = _a === void 0 ? 'list' : _a, _b = options.force, force = _b === void 0 ? false : _b;
                        return [4 /*yield*/, this.checkUpdateInterval(options)];
                    case 1:
                        checkResult = _c.sent();
                        if (checkResult.resultCode !== SyncResultCode.Success) {
                            return [2 /*return*/, checkResult];
                        }
                        lock = createLock();
                        return [4 /*yield*/, lock.lock("offline_" + secretId, { source: source })];
                    case 2:
                        offlineLock = _c.sent();
                        if (!offlineLock.isSuccess) {
                            Log.warn('SyncOfflineData. 竞争离线锁失败，同步接口异常结束', padId, secretId, source, force, padType, offlineLock);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.GetDocLockError,
                                    subResultCode: -1,
                                    message: '竞争离线锁失败',
                                }];
                        }
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 8, 9, 11]);
                        // 提交中回调
                        onCommiting && onCommiting(padId);
                        Log.log('SyncOfflineData. 第一步：带数据创建文档', padId, secretId, source, force, padType);
                        return [4 /*yield*/, this.commitLocalFile(options)];
                    case 4:
                        createFileResult = _c.sent();
                        if (createFileResult.resultCode !== SyncResultCode.Success) {
                            onCommitFinished && onCommitFinished(false, padId);
                            return [2 /*return*/, createFileResult];
                        }
                        Log.log('SyncOfflineData. 第二步，提交未提交的离线数据', padId, secretId, source, force, padType);
                        return [4 /*yield*/, this.commitUncommitData(options)];
                    case 5:
                        commitResult = _c.sent();
                        if (commitResult.resultCode !== SyncResultCode.Success) {
                            onCommitFinished && onCommitFinished(false, padId);
                            return [2 /*return*/, commitResult];
                        }
                        // 提交完成回调
                        onCommitFinished && onCommitFinished(true, padId);
                        Log.log('SyncOfflineData. 第三步，检查版本更新', padId, secretId, source, force, padType);
                        // 请求一个特殊url  后台才能升级版本
                        return [4 /*yield*/, this.checkVersionUpdate(padType, padId)];
                    case 6:
                        // 请求一个特殊url  后台才能升级版本
                        _c.sent();
                        Log.log('SyncOfflineData. 第四步，预拉离线缓存数据', padId, secretId, source, force, padType);
                        return [4 /*yield*/, this.fetchAndStoreDocumentCache(options)];
                    case 7:
                        fetchAndStoreResult = _c.sent();
                        if (fetchAndStoreResult.resultCode !== SyncResultCode.Success) {
                            return [2 /*return*/, fetchAndStoreResult];
                        }
                        result = fetchAndStoreResult.data;
                        return [3 /*break*/, 11];
                    case 8:
                        error_1 = _c.sent();
                        Log.error('SyncOfflineData. 同步文档异常结束', error_1 === null || error_1 === void 0 ? void 0 : error_1.stack);
                        return [2 /*return*/, {
                                resultCode: SyncResultCode.SyncOfflineDataUnknownError,
                                subResultCode: -1,
                                message: 'SyncOfflineDataUnknownError。 同步离线数据的时候发生了未知错误 被catch住了。',
                                error: error_1 || new Error('SyncOfflineDataUnknownError'),
                            }];
                    case 9: 
                    // 释放该文档离线编辑锁
                    return [4 /*yield*/, lock.release("offline_" + secretId)];
                    case 10:
                        // 释放该文档离线编辑锁
                        _c.sent();
                        return [7 /*endfinally*/];
                    case 11:
                        Log.log('SyncOfflineData. 结束', padId, secretId, source, force, padType);
                        return [2 /*return*/, {
                                resultCode: SyncResultCode.Success,
                                subResultCode: 0,
                                message: 'Success',
                                data: result,
                            }];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.checkUpdateInterval = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var padId, secretId, padType, _a, source, _b, force, condition, statusQueryResult, documentStatus;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        padId = options.padId, secretId = options.secretId, padType = options.padType, _a = options.source, source = _a === void 0 ? 'list' : _a, _b = options.force, force = _b === void 0 ? false : _b;
                        if (!!force) return [3 /*break*/, 2];
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, padId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.get(TableName.DOCUMENT_STATUS, condition)];
                    case 1:
                        statusQueryResult = _c.sent();
                        if (statusQueryResult.error && !isNoResultError(statusQueryResult.error)) {
                            // 查询异常
                            Log.warn('SyncOfflineData. 查询DocumentStatus发生错误', padId, secretId, source, force, padType, statusQueryResult.error);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.GetDocumentStatusError,
                                    subResultCode: -1,
                                    message: '数据库查询DocumentStatus发生错误',
                                    error: statusQueryResult.error,
                                }];
                        }
                        if (!statusQueryResult.error) { // 查询到结果的话 就做个对比看是否要节流  如果查不到数据  说明没有同步过 那就不节流
                            documentStatus = statusQueryResult.data;
                            if (Date.now() - documentStatus.lastSyncTime < 10 * 60 * 1000) {
                                // 十分钟内刚同步过，节流 不同步了
                                Log.warn('SyncOfflineData. RejcectByThrottle节流了', padId, secretId, source, force, padType);
                                return [2 /*return*/, {
                                        resultCode: SyncResultCode.RejcectByThrottleError,
                                        subResultCode: -1,
                                        message: "\u540C\u6B65\u4EFB\u52A1\u5931\u8D25\uFF0C10\u5206\u949F\u5185\u5DF2\u7ECF\u540C\u6B65\u8FC7\u4E86\uFF0C\u8282\u6D41\u4E0B\u3002\u4E0A\u6B21\u540C\u6B65\u65F6\u95F4 " + new Date(documentStatus.lastSyncTime),
                                    }];
                            }
                        }
                        _c.label = 2;
                    case 2: return [2 /*return*/, {
                            resultCode: SyncResultCode.Success,
                            subResultCode: -1,
                            message: '同步任务开始',
                        }];
                }
            });
        });
    };
    /**
     * 带数据创建文档
     * @param options
     */
    BaseBusinessHelper.prototype.commitLocalFile = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var padId, secretId, source, force, padType, padInfo, createResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        padId = options.padId, secretId = options.secretId, source = options.source, force = options.force, padType = options.padType;
                        return [4 /*yield*/, this.getPadInfo(padId)];
                    case 1:
                        padInfo = _a.sent();
                        if (!padInfo) {
                            Log.error('commitLocalFile. getPadInfoError. ', padId, secretId, source, force, padType);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.CreateFileError,
                                    subResultCode: -1000,
                                    message: 'commitLocalFile 查询文档PadInfo发生错误，PadInfo不存在或者数据库操作错误。',
                                }];
                        }
                        if (!(padInfo && (padInfo.status === PadStatus.NEW || padInfo.status === PadStatus.LOCAL))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.createFileWithData(padId, padType, padInfo.folder)];
                    case 2:
                        createResult = _a.sent();
                        if (createResult.error) {
                            Log.error('commitLocalFile 带数据创建文档失败', padId, secretId, source, force, padType, createResult.error);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.CreateFileError,
                                    subResultCode: -2000,
                                    message: 'commitLocalFile 带数据创建文档失败了。',
                                    error: createResult.error,
                                }];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, {
                            resultCode: SyncResultCode.Success,
                            subResultCode: -1,
                            message: 'commitLocalFile 正常',
                        }];
                }
            });
        });
    };
    /**
     * 提交未提交的离线数据
     * @param options
     */
    BaseBusinessHelper.prototype.commitUncommitData = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var padId, secretId, source, force, padType, queryResult, unCommittedData, commitResult, misschanges, updateResult;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        padId = options.padId, secretId = options.secretId, source = options.source, force = options.force, padType = options.padType;
                        return [4 /*yield*/, this.getUnCommitedData(padId)];
                    case 1:
                        queryResult = _b.sent();
                        if (queryResult.error) {
                            Log.error(queryResult.error);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.GetUncommitDataError,
                                    subResultCode: -1,
                                    message: 'commitUncommitData 查询本地未提交数据错误。',
                                    error: queryResult.error,
                                }];
                        }
                        Log.log('commitUncommitData. 查询本地未提交离线数据', padId, secretId, source, force, padType, queryResult.data.length);
                        unCommittedData = queryResult.data;
                        if (!(unCommittedData.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.batchCommitOfflineData(padId, secretId, unCommittedData)];
                    case 2:
                        commitResult = _b.sent();
                        if (commitResult.resultCode !== SyncResultCode.Success) {
                            // 提交后出错了
                            Log.error('commitUncommitData. 提交离线未提交数据时出错了，同步失败', padId, secretId, source, force, padType);
                            return [2 /*return*/, commitResult];
                        }
                        misschanges = commitResult.data;
                        if (!(misschanges.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.updateDocUncommitedData(padId, misschanges)];
                    case 3:
                        updateResult = _b.sent();
                        if (updateResult.error) {
                            // 更新数据库的时候出错了 同步失败
                            Log.error('SyncOfflineData. 更新未提交数据为已提交数据出错', padId, secretId, source, force, padType, updateResult.error, (_a = updateResult.error) === null || _a === void 0 ? void 0 : _a.stack);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.UpdateUnCommitedDataError,
                                    subResultCode: -1,
                                    message: 'commitUncommitData 提交成功后更新数据库中本地未提交离线数据时发生错误。',
                                    error: updateResult.error,
                                }];
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/, {
                            resultCode: SyncResultCode.Success,
                            subResultCode: -1,
                            message: 'commitUncommitData 正常',
                        }];
                }
            });
        });
    };
    /**
     * 拉取缓存并更新到数据库
     * @param options
     */
    BaseBusinessHelper.prototype.fetchAndStoreDocumentCache = function (options) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var padId, secretId, source, force, padType, _e, deleteOldCache, rev, isManualOffline, preFetchResult, _f, dver, allBlockData, rangePrivilege, preFetchOfflineItemList, updateResult, manualPadInfo, rangeResult, toBeUpdate, padResult, documentStatus, updateStatusResult;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        padId = options.padId, secretId = options.secretId, source = options.source, force = options.force, padType = options.padType, _e = options.deleteOldCache, deleteOldCache = _e === void 0 ? true : _e, rev = options.rev, isManualOffline = options.isManualOffline;
                        return [4 /*yield*/, this.preFetchDocData(padId, secretId, rev)];
                    case 1:
                        preFetchResult = _g.sent();
                        if (preFetchResult.resultCode !== SyncResultCode.Success) {
                            Log.error('SyncOfflineData. 拉取新的离线数据失败, 同步失败', padId, secretId, source, force, padType, logSyncResult(preFetchResult));
                            return [2 /*return*/, preFetchResult];
                        }
                        _f = preFetchResult.data, dver = _f.dver, allBlockData = _f.allBlockData, rangePrivilege = _f.rangePrivilege;
                        Log.log('SyncOfflineData. 第五步，删除本地离线数据&写入新的预拉数据', padId, secretId, source, force, padType);
                        preFetchOfflineItemList = allBlockData.map(function (blockData) {
                            var offlineData = _this.blockData2OfflineData(blockData, dver);
                            return offlineData;
                        });
                        return [4 /*yield*/, this.updateDocOfflineData(padId, preFetchOfflineItemList, deleteOldCache, rev)];
                    case 2:
                        updateResult = _g.sent();
                        if (updateResult.error) {
                            // 最后更新离线数据的时候失败了
                            Log.error('SyncOfflineData. 写入离线缓存数据错误.', padId, secretId, source, force, padType, rev, dver, preFetchOfflineItemList.length, updateResult.error, (_a = updateResult.error) === null || _a === void 0 ? void 0 : _a.stack);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.UpdatePreFetchOfflienDataError,
                                    subResultCode: -1,
                                    message: 'updateDocOfflineData 操作数据库更新离线缓存数据失败',
                                    error: updateResult.error,
                                }];
                        }
                        return [4 /*yield*/, this.getManualPadInfo(secretId)];
                    case 3:
                        manualPadInfo = _g.sent();
                        if ((!manualPadInfo.error && manualPadInfo.data) || isManualOffline) {
                            allBlockData.forEach(function (blockData) {
                                _this.cacheImageData(blockData);
                            });
                        }
                        if (!rangePrivilege) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.cacheRangePrivilege(padId, rangePrivilege)];
                    case 4:
                        rangeResult = _g.sent();
                        if (rangeResult && rangeResult.error) {
                            Log.error('cacheRangePrivilege. 写入离线区域权限数据错误.', (_b = rangeResult.error) === null || _b === void 0 ? void 0 : _b.stack);
                        }
                        _g.label = 5;
                    case 5:
                        toBeUpdate = isManualOffline !== undefined ? {
                            dver: dver,
                            isOfflineCache: true,
                            isManualOffline: isManualOffline,
                        } : {
                            dver: dver,
                            isOfflineCache: true,
                        };
                        return [4 /*yield*/, this.updatePadInfo(padId, toBeUpdate)];
                    case 6:
                        padResult = _g.sent();
                        if (padResult.error) {
                            // 更新padinfo失败
                            Log.error('SyncOfflineData. 增量更新padInfo错误.', padId, secretId, source, force, padType, rev, dver, padResult.error, (_c = padResult.error) === null || _c === void 0 ? void 0 : _c.stack);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.UpdatePadInfoError,
                                    subResultCode: -1,
                                    message: 'updatePadInfo 操作数据库更新离线PadInfo缓存数据失败',
                                    error: padResult.error,
                                }];
                        }
                        documentStatus = new DocumentStatus({
                            uid: this.parent.user.getUserId(),
                            globalPadId: padId,
                            secretId: secretId,
                            lastSyncTime: Date.now(),
                        });
                        return [4 /*yield*/, this.updateDocumentStatus(documentStatus)];
                    case 7:
                        updateStatusResult = _g.sent();
                        if (updateStatusResult.error) {
                            // 更新文档最后更新时间戳失败了  不过这个只影响节流 就算了  不报错了
                            Log.error('SyncOfflineData. 更新文档Status表错误.', padId, secretId, source, force, padType, rev, dver, updateStatusResult.error, (_d = updateStatusResult.error) === null || _d === void 0 ? void 0 : _d.stack);
                        }
                        this.parent.mapDocumentVersion(dver, reconstructDocUrl(padType, secretId));
                        return [2 /*return*/, {
                                resultCode: SyncResultCode.Success,
                                subResultCode: 0,
                                message: 'fetchAndStoreDocumentCache Success',
                                data: padResult.data[0],
                            }];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.updateDocumentStatus = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.database.update(TableName.DOCUMENT_STATUS, status)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 更新文档
     */
    BaseBusinessHelper.prototype.updatePadInfo = function (globalPadId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var condition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = new QueryCondition()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, globalPadId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.updateField(TableName.PAD_INFO, condition, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 获取指定文档本地所有未提交的离线数据
     * @param padId 文档唯一ID
     */
    BaseBusinessHelper.prototype.getUnCommitedData = function (padId) {
        return __awaiter(this, void 0, void 0, function () {
            var condition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, padId)
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.COMMITING, OFFLINE_ITEM_TYPE.WATTING, OFFLINE_ITEM_TYPE.QUEUE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.getAll(TableName.OFFLINE_DATA, condition)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 删除指定文档本地所有离线数据
     * @param padId
     * @param all 是否全部都删除 如果为false只删除未提交  如果为true  删除已提交和未提交
     */
    BaseBusinessHelper.prototype.clearDocOfflineData = function (padId, all) {
        if (all === void 0) { all = true; }
        return __awaiter(this, void 0, void 0, function () {
            var condition, result, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, padId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.delete(TableName.OFFLINE_DATA, condition)];
                    case 1:
                        result = _d.sent();
                        if (!all) return [3 /*break*/, 8];
                        _a = !result.error;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.database.delete(TableName.DOCUMENT_DATA, condition)];
                    case 2:
                        _a = (result = _d.sent());
                        _d.label = 3;
                    case 3:
                        _a; // 删除已提交
                        _b = !result.error;
                        if (!_b) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.database.delete(TableName.DOCUMENT_STATUS, condition)];
                    case 4:
                        _b = (result = _d.sent());
                        _d.label = 5;
                    case 5:
                        _b; // 删除status表信息
                        _c = !result.error;
                        if (!_c) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.database.updateField(TableName.PAD_INFO, condition, {
                                isOfflineCache: false,
                            })];
                    case 6:
                        _c = (result = _d.sent());
                        _d.label = 7;
                    case 7:
                        _c; // 更新padInfo表
                        _d.label = 8;
                    case 8: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 更新指定文档数据  删除旧的离线数据 写入新的离线数据
     * @param padId 文档唯一ID
     * @param allBlockData 文档新的离线数据信息
     * @param deleteOldCache 是否删除旧的缓存  如果不删除 那就只更新
     * @param rev 更新数据的基准版本号，删除旧数据的时候只会删除小于等于该版本的数据 然后用新数据去替换 如果不指定该字段 则删除所有的旧数据
     */
    BaseBusinessHelper.prototype.updateDocOfflineData = function (padId, allBlockData, deleteOldCache, rev) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, padId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        if (rev !== undefined) {
                            condition.addCondition('version', QUERY_CONDITION_TYPE.UPPER_BOUND, { upper: rev, open: false });
                        }
                        if (!deleteOldCache) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.database.deleteAndWrite(TableName.DOCUMENT_DATA, condition, allBlockData)];
                    case 1: 
                    // 如果需要删除 那就用deleteAndWrite开事务先删除后更新
                    return [2 /*return*/, _a.sent()];
                    case 2:
                        data = allBlockData.map(function (item) {
                            return {
                                tableName: TableName.DOCUMENT_DATA,
                                data: item,
                            };
                        });
                        return [4 /*yield*/, this.database.updateMultiTableData(data)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 组发送离线消息的包体
     *
     * @private
     * @param {string} padId
     * @param {any[]} offlineData
     * @memberof BaseBusinessHelper
     */
    BaseBusinessHelper.prototype.composeOfflineData = function (padId, offlineData) {
        var uid = this.parent.user.getUserId();
        var offlineDataItem = offlineData[0]; // 同一组离线数据，公共参数取第一个就可以了。
        var content = {
            common: {
                type: 'USER_CHANGES',
                offlineMsg: true,
                docid: padId,
                uid: uid,
                dver: offlineDataItem.dver,
                base_rev: offlineDataItem.type === OFFLINE_ITEM_TYPE.INIT ? offlineDataItem.version : offlineDataItem.data.baseVersion,
                code_ver: offlineDataItem.docType === FILE_TYPE.EXCEL ? 1 : 0,
                session_type: 0,
                gray: window._grayVersion ? window._grayVersion : 0,
                generalpacket: this.getHeaderGeneralPacket(),
                pver: offlineDataItem.docType === FILE_TYPE.WORD ? 2 : 1,
                uuId: offlineDataItem.type === OFFLINE_ITEM_TYPE.INIT ? this.parent.user.getUserId() : offlineDataItem.data.data.uuId,
            },
            respective: offlineData.filter(function (item) {
                if (item.type !== OFFLINE_ITEM_TYPE.INIT) {
                    return item;
                }
            })
                .map(function (item) {
                var data = item.data.data;
                var result = {
                    task_id: data.taskId,
                    subId: data.subId,
                    oSubId: data.oSubId || false,
                    head: data.head,
                    keydata: data.keyData || false,
                    changeSetCount: data.changeData ? 1 : data.changeSetCount !== undefined ? data.changeSetCount : data.mutations.length,
                    changeset: (data.changeset ? data.changeset : JSON.stringify(data.changeData || data.mutations || '[]')),
                    apool: data.apool,
                };
                if (offlineDataItem.docType === FILE_TYPE.EXCEL) {
                    result.changeset = result.changeset + "\n";
                }
                return result;
            }),
        };
        return content;
    };
    /**
     * 批量提交本地指定文档的离线数据
     * @param padId 文档唯一ID
     */
    BaseBusinessHelper.prototype.batchCommitOfflineData = function (padId, secretId, offlineData) {
        return __awaiter(this, void 0, void 0, function () {
            var result, isFailedBefore, content, commitResult, response, retCode, misschanges, errorCodes, documentStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = offlineData;
                        if (result.length === 0) {
                            // 没有未提交数据 直接更新
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.CommitOfflineDataError,
                                    subResultCode: -1000,
                                    message: 'batchCommitOfflineData 参数错误。待提交的OfflineData数组长度为0',
                                }];
                        }
                        return [4 /*yield*/, this.isCommitFailedBefore(padId, offlineData)];
                    case 1:
                        isFailedBefore = _a.sent();
                        if (isFailedBefore)
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.CommitOfflineDataError,
                                    subResultCode: -1001,
                                    message: 'batchCommitOfflineData 该离线数据曾经提交过且报错',
                                }];
                        result = this.offlineDataSort(result);
                        content = this.composeOfflineData(padId, offlineData);
                        return [4 /*yield*/, this.commitOfflineData(padId, content)];
                    case 2:
                        commitResult = _a.sent();
                        if (commitResult.error) {
                            // 提交出错了
                            Log.error(commitResult.error);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.CommitOfflineDataError,
                                    subResultCode: -2000,
                                    message: 'batchCommitOfflineData 批量提交离线数据时发生错误。',
                                    error: commitResult.error,
                                }];
                        }
                        response = commitResult.data;
                        retCode = response.retcode;
                        if (retCode === 0) {
                            misschanges = this.createMisschangeData(padId, secretId, response.Data);
                            return [2 /*return*/, {
                                    resultCode: SyncResultCode.Success,
                                    subResultCode: -1,
                                    data: misschanges,
                                    message: 'batchCommitOfflineData 提交正常。',
                                }];
                        }
                        Log.error("batchCommitOfflineData retcode:" + retCode);
                        errorCodes = [40005, 40003, 40034];
                        if (errorCodes.indexOf(retCode) >= 0) {
                            documentStatus = new DocumentStatus({
                                uid: this.parent.user.getUserId(),
                                globalPadId: padId,
                                secretId: secretId,
                                lastSyncTime: Date.now(),
                                lastErrorTime: Date.now(),
                            });
                            // 这里就不await了，异步更新
                            this.updateDocumentStatus(documentStatus);
                        }
                        return [2 /*return*/, {
                                resultCode: SyncResultCode.CommitOfflineDataError,
                                subResultCode: -2001,
                                message: "batchCommitOfflineData \u6279\u91CF\u63D0\u4EA4\u79BB\u7EBF\u6570\u636E\u65F6\u53D1\u751F\u9519\u8BEF\u3002retCode\u4E0D\u4E3A0 retCode=" + retCode,
                            }];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.isCommitFailedBefore = function (padId, offlineData) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, statusQueryResult, lastCommitErrorTime_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, padId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.get(TableName.DOCUMENT_STATUS, condition)];
                    case 1:
                        statusQueryResult = _a.sent();
                        if (statusQueryResult.error) {
                            return [2 /*return*/, false];
                        }
                        if (statusQueryResult.data && statusQueryResult.data.lastErrorTime) {
                            lastCommitErrorTime_1 = statusQueryResult.data.lastErrorTime;
                            if (!offlineData.some(function (cs) { return cs.createTime > lastCommitErrorTime_1; })) {
                                return [2 /*return*/, true];
                            }
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.getHeaderGeneralPacket = function () {
        var header = {};
        if (window.__globalReleaseVersion) {
            header.rel_rev = window.__globalReleaseVersion;
        }
        return header;
    };
    /**
     * 提交本地离线数据CGI请求
     * @param padId 文档唯一ID
     * @param offlineData 文档离线数据（已处理成后台特定要求特定格式）
     */
    BaseBusinessHelper.prototype.commitOfflineData = function (padId, offlineData) {
        return __awaiter(this, void 0, void 0, function () {
            var commitRequestUrl, content;
            return __generator(this, function (_a) {
                commitRequestUrl = "/dop-api/commitchanges?padId=" + padId + "&xsrf=" + getXsrf();
                content = JSON.stringify(offlineData);
                content = encodeURIComponent(content);
                return [2 /*return*/, CGI.sendCommonRequest(commitRequestUrl, Method.POST, "data=" + content)];
            });
        });
    };
    BaseBusinessHelper.prototype.getGlobalPadIdBySecretId = function (secretId, queryString, prefetch) {
        if (prefetch === void 0) { prefetch = true; }
        return __awaiter(this, void 0, void 0, function () {
            var padInfo, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPadInfo(secretId, PadIdType.SECRET)];
                    case 1:
                        padInfo = _a.sent();
                        if (padInfo) {
                            return [2 /*return*/, padInfo.globalPadId];
                        }
                        return [4 /*yield*/, this.getClientVarsBySecretId(secretId, queryString, prefetch)];
                    case 2:
                        data = _a.sent();
                        if (data.error) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, data.data.globalPadId];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.getClientVarsBySecretId = function (secretId, queryString, prefetch) {
        if (prefetch === void 0) { prefetch = true; }
        return __awaiter(this, void 0, void 0, function () {
            var preFetchResult, response, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CGI.fetchDocData(secretId, queryString, prefetch)];
                    case 1:
                        preFetchResult = _a.sent();
                        if (preFetchResult.error) {
                            return [2 /*return*/, new Result(preFetchResult.error)];
                        }
                        response = preFetchResult.data;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        data = this.convertDataToClientVars(response);
                        if (data.padType === 'blankpage' || data.isBlankPage === true) {
                            // 数据空白
                            Log.error('文档数据不存在，或者无权限');
                            return [2 /*return*/, new Result(new Error('FileNotExsit'))];
                        }
                        // 尝试创建padInfo
                        return [4 /*yield*/, this.createPadInfoFromClientVars(data)];
                    case 3:
                        // 尝试创建padInfo
                        _a.sent();
                        return [2 /*return*/, new Result(undefined, data)];
                    case 4:
                        e_1 = _a.sent();
                        Log.error('解析后台预拉数据异常', e_1);
                        return [2 /*return*/, new Result(e_1 || new Error('ParseResponseError'))];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 解析文档正文数据
     * @param data 后台返回的文档数据（非JSON结构）
     */
    BaseBusinessHelper.prototype.convertDataToClientVars = function (data) {
        var ejsData = this.unpackEjsData(data);
        if (ejsData) {
            var head = ejsData.head.value;
            if (ejsData.text && ejsData.text.value) {
                var escapedText = head.needEscape ? escape(ejsData.text.value) : ejsData.text.value;
                head.clientVars.collab_client_vars.initialAttributedText.text = escapedText;
                head.clientVars.collab_client_vars.initialAttributedText.attribs = ejsData.attribs.value;
            }
            return head.clientVars;
        }
        return undefined;
    };
    BaseBusinessHelper.prototype.unpackEjsData = function (str) {
        var pos = 0;
        var data = str || '';
        var end = data.length;
        var dataOne = {
            type: '',
            value: null,
        };
        var dataTwo = {
            type: '',
            value: null,
        };
        var dataThrity = {
            type: '',
            value: null,
        };
        var obj = {
            text: dataOne,
            attribs: dataTwo,
            head: dataThrity,
        };
        while (pos < end) {
            var head = data.slice(pos, pos + 50).split('\n');
            if (head && head.length >= 3) {
                var key = head[0];
                var type = head[1];
                var lens = parseInt(head[2], 10);
                pos += head[0].length + head[1].length + head[2].length + 3;
                var value = data.slice(pos, pos + lens);
                pos += lens + 1;
                if (key === 'text') {
                    obj.text.type = type;
                    if (type === 'json') {
                        obj.text.value = JSON.parse(value);
                    }
                    else {
                        obj.text.value = value;
                    }
                }
                else if (key === 'head') {
                    obj.head.type = type;
                    if (type === 'json') {
                        obj.head.value = JSON.parse(value);
                    }
                    else {
                        obj.head.value = value;
                    }
                }
                else if (key === 'attribs') {
                    obj.attribs.type = type;
                    if (type === 'json') {
                        obj.attribs.value = JSON.parse(value);
                    }
                    else {
                        obj.attribs.value = value;
                    }
                }
            }
            else {
                break;
            }
        }
        return obj;
    };
    BaseBusinessHelper.prototype.checkVersionUpdate = function (padType, padId) {
        return __awaiter(this, void 0, void 0, function () {
            var type, checkUrl, checkResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = this.getTypeStringWithPadType(padType);
                        checkUrl = "https://docs.qq.com/cgi/gateway/dver/gray?padId=" + padId + "&type=" + type;
                        return [4 /*yield*/, CGI.sendCommonRequest(checkUrl, Method.GET, undefined, 'custom')];
                    case 1:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            Log.error('checkVersionUpdate error.', checkResult.error);
                        }
                        Log.log('checkVersionUpdate. response=', checkResult.data);
                        return [2 /*return*/, checkResult];
                }
            });
        });
    };
    /**
     * 预拉取文档数据
     * @param padId 文档唯一ID
     */
    BaseBusinessHelper.prototype.preFetchDocData = function (padId, secretId, rev) {
        return __awaiter(this, void 0, void 0, function () {
            var preFetchUrl, preFetchResult, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        preFetchUrl = this.getFetchUrl(padId, secretId, rev);
                        return [4 /*yield*/, CGI.sendCommonRequest(preFetchUrl, Method.GET, undefined, 'custom')];
                    case 1:
                        preFetchResult = _a.sent();
                        if (preFetchResult.error) {
                            return [2 /*return*/, this.handleCommonRequestError(preFetchResult)];
                        }
                        response = preFetchResult.data;
                        return [2 /*return*/, this.handlePreFetchDocData(padId, response)];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.handleCommonRequestError = function (preFetchResult) {
        if (preFetchResult.error.errorType === 'HttpError') {
            return {
                resultCode: SyncResultCode.PreFetchDocDataError,
                // @ts-ignore
                subResultCode: preFetchResult.error.statusCode,
                message: 'Prefetch Data请求遇到HttpError',
                error: preFetchResult.error,
            };
        }
        if (preFetchResult.error.message === 'TimeOutError') {
            return {
                resultCode: SyncResultCode.PreFetchDocDataError,
                // @ts-ignore
                subResultCode: -200801,
                message: 'Prefetch Data请求超时',
                error: preFetchResult.error,
            };
        }
        return {
            resultCode: SyncResultCode.PreFetchDocDataError,
            subResultCode: -200802,
            message: 'Prefetch Data请求遇到其他错误',
            error: preFetchResult.error,
        };
    };
    /**
     * 解析直出数据中包含的header信息  也就是文档的所有子表信息
     * @param clientVars
     */
    BaseBusinessHelper.prototype.getSubBlockList = function (clientVars) {
        var headers = this.parseHeadersFromClientVars(clientVars);
        return headers;
    };
    // /**
    //  * 批量拉取子表数据
    //  * @param padId
    //  * @param subBlockList
    //  * @param rev 拉取的特定版本号
    //  */
    // protected async batchFetchSubBlockData(padId: string, subBlockList: Array<{ id: string; name: string }>, rev: number) {
    //     let allSubBlockData = new Array<BlockData>();
    //     for (let i = 0; i < subBlockList.length; i++) {
    //         let subBlockInfo = subBlockList[i];
    //         let preFetchSubBlockResult = await this.preFetchSingleSubBlockData(padId, subBlockInfo.id, rev);
    //         if (preFetchSubBlockResult.error) {
    //             // 拉取子表失败
    //             Log.error(preFetchSubBlockResult.error);
    //             return new Result(preFetchSubBlockResult.error, allSubBlockData);
    //         }
    //         let subBlockData = preFetchSubBlockResult.data;
    //         allSubBlockData.push(subBlockData);
    //     }
    //     return new Result(undefined, allSubBlockData);
    // }
    BaseBusinessHelper.prototype.pushState = function (url, replace) {
        var history = window.history;
        try {
            if (replace) {
                history.replaceState(null, '', url);
            }
            else {
                history.pushState(null, '', url);
            }
        }
        catch (e) {
            window.location[replace ? 'replace' : 'assign'](url);
        }
    };
    /**
     * 判断文档是否是已创建
     * @param globalPadId
     */
    BaseBusinessHelper.prototype.isFileCreated = function (globalPadId) {
        return __awaiter(this, void 0, void 0, function () {
            var padInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPadInfo(globalPadId, PadIdType.GLOBAL)];
                    case 1:
                        padInfo = _a.sent();
                        if (!padInfo) {
                            // pad信息不存在
                            Log.error('文档基本信息不存在');
                            return [2 /*return*/, new Result(new Error('FileNotExsit'))];
                        }
                        if (padInfo.status === PadStatus.NORMAL) {
                            return [2 /*return*/, new Result(undefined, true)];
                        }
                        return [2 /*return*/, new Result(undefined, false)];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.createFileWithData = function (globalPadId, padType, folderId) {
        if (padType === void 0) { padType = FILE_TYPE.EXCEL; }
        if (folderId === void 0) { folderId = '/'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.createFile(globalPadId, padType, true, folderId)];
            });
        });
    };
    /**
     * 这个接口有对外暴露直接给其他业务使用，返回值就不修改成SyncResult类型了
     * @param globalPadId
     * @param padType
     * @param withData
     * @param folderId
     */
    BaseBusinessHelper.prototype.createFile = function (globalPadId, padType, withData, folderId) {
        var _a;
        if (padType === void 0) { padType = FILE_TYPE.EXCEL; }
        if (withData === void 0) { withData = true; }
        return __awaiter(this, void 0, void 0, function () {
            var docType, padInfo, unCommittedDataResult, offlineDatas, url, body, responseResult, responseData, getOfflineDataResult, offlineData, backupResult, condition, currentTime, defaultDocDataResult, defaultClientVars, misschanges, updateResult_1, updateResult, newClientVars;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        docType = padType;
                        return [4 /*yield*/, this.getPadInfo(globalPadId, PadIdType.GLOBAL)];
                    case 1:
                        padInfo = _b.sent();
                        if (!padInfo) {
                            Log.error('获取文档padInfo失败了', globalPadId);
                            return [2 /*return*/, new Result(new Error('NoPadInfoError'))];
                        }
                        if (padInfo.status === PadStatus.NORMAL) {
                            // 已经创建过了 不要再创建了
                            Log.error('已经创建过该文档了，不用再创建了', globalPadId);
                            return [2 /*return*/, new Result(new Error('AlreadyCreatedError'))];
                        }
                        return [4 /*yield*/, this.getLocalCreateFileData(globalPadId, withData)];
                    case 2:
                        unCommittedDataResult = _b.sent();
                        if (unCommittedDataResult.error) {
                            Log.error(unCommittedDataResult.error, '读取文档离线未提交数据失败');
                            return [2 /*return*/, unCommittedDataResult];
                        }
                        offlineDatas = unCommittedDataResult.data;
                        url = '/cgi-bin/online_docs/createdoc_new';
                        body = this.generateCreateFileBody({
                            globalPadId: globalPadId, docType: docType, folderId: folderId, withData: withData,
                        }, padInfo, offlineDatas);
                        return [4 /*yield*/, CGI.sendCommonRequest(url, Method.POST, body)];
                    case 3:
                        responseResult = _b.sent();
                        if (responseResult.error) {
                            // 创建失败
                            Log.error(responseResult.error, '创建文档请求失败');
                            return [2 /*return*/, responseResult];
                        }
                        responseData = responseResult.data;
                        Log.info('create file response:', JSON.stringify(responseData));
                        // 创建失败
                        if (responseData.retcode !== 0) {
                            Log.error('创建文档失败');
                            return [2 /*return*/, new Result(new Error('CreatFileError'), responseData)];
                        }
                        if (!(responseData.is_doc_id_dup === true)) return [3 /*break*/, 10];
                        // 1.1 后台返回文档 id 重复，且是和自己的文档 id 重复
                        if (responseData.is_dup_id_owner) {
                            Log.error('后台返回文档 id 重复，且是和自己的文档 id 重复');
                            return [2 /*return*/, new Result(new HttpError(0, 10034, 'DocumentIdDuplicated'), {
                                    retcode: 10033,
                                    url: responseData.doc_url,
                                })];
                        }
                        return [4 /*yield*/, this.getUncommitedOfflineData()];
                    case 4:
                        getOfflineDataResult = _b.sent();
                        if (getOfflineDataResult.error) {
                            Log.error('后台返回文档 id 重复，备份离线数据时加载离线数据异常');
                            return [2 /*return*/, new Result(new Error("DocumentIdDuplicated \u52A0\u8F7D\u79BB\u7EBF\u6570\u636E\u5F02\u5E38\u539F\u56E0: " + ((_a = getOfflineDataResult.error) === null || _a === void 0 ? void 0 : _a.message)), {
                                    retcode: 10033,
                                    url: responseData.doc_url,
                                })];
                        }
                        offlineData = convertToArkOfflineData(getOfflineDataResult.data);
                        return [4 /*yield*/, backupOfflineData(offlineData)];
                    case 5:
                        backupResult = _b.sent();
                        Log.info("\u540E\u53F0\u8FD4\u56DE\u6587\u6863 id \u91CD\u590D\uFF0C\u5907\u4EFD\u79BB\u7EBF\u6570\u636E, result = " + backupResult);
                        condition = QueryCondition.newInstance()
                            .addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, globalPadId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        return [4 /*yield*/, this.database.delete(TableName.PAD_INFO, condition)];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.database.delete(TableName.OFFLINE_DATA, condition)];
                    case 7:
                        _b.sent();
                        return [4 /*yield*/, this.database.delete(TableName.DOCUMENT_DATA, condition)];
                    case 8:
                        _b.sent();
                        return [4 /*yield*/, this.database.delete(TableName.DOCUMENT_STATUS, condition)];
                    case 9:
                        _b.sent();
                        return [2 /*return*/, new Result(new HttpError(0, 10033, 'DocumentIdDuplicated'), {
                                retcode: 10033,
                                url: responseData.doc_url,
                            })];
                    case 10:
                        currentTime = Date.now();
                        padInfo.status = PadStatus.NORMAL;
                        padInfo.last_modify_ts = currentTime;
                        padInfo.lastSyncTime = currentTime;
                        return [4 /*yield*/, this.getDefaultDocData(globalPadId, PadIdType.GLOBAL)];
                    case 11:
                        defaultDocDataResult = _b.sent();
                        if (defaultDocDataResult.error) {
                            return [2 /*return*/, defaultDocDataResult];
                        }
                        defaultClientVars = defaultDocDataResult.data.data;
                        if (!responseData.miss_changes) return [3 /*break*/, 13];
                        if (!(padType === FILE_TYPE.EXCEL || (padType === FILE_TYPE.WORD && withData))) return [3 /*break*/, 13];
                        misschanges = this.createMisschangeData(globalPadId, padInfo.secretId
                            || defaultClientVars.data.collab_client_vars.client.upid, JSON.parse(responseData.miss_changes));
                        if (!(misschanges.length > 0)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.updateDocUncommitedData(globalPadId, misschanges)];
                    case 12:
                        updateResult_1 = _b.sent();
                        if (updateResult_1.error) {
                            // 更新数据库的时候出错了 同步失败
                            Log.error(updateResult_1.error);
                            return [2 /*return*/, updateResult_1];
                        }
                        _b.label = 13;
                    case 13:
                        defaultClientVars.isTemp = false;
                        return [4 /*yield*/, this.updateClientVarsSocketInfo(globalPadId, defaultClientVars)];
                    case 14:
                        updateResult = _b.sent();
                        if (updateResult.error) {
                            return [2 /*return*/, updateResult];
                        }
                        // WORD 里面先不更新attrbutedtext,带数据创建和不带数据创建都直接更新rev到升级消息到1号版本，但是升级消息的newchance不能写入indxDB
                        if (padType === FILE_TYPE.WORD) {
                            updateResult.data.collab_client_vars.rev = 0;
                        }
                        updateResult.data.isLocalDoc = false;
                        updateResult.data.padStatus = PadStatus.NORMAL;
                        newClientVars = this.clientVars2OfflineData(globalPadId, updateResult.data, true);
                        // 写入数据库
                        return [4 /*yield*/, this.database.updateMultiTableData([
                                { tableName: TableName.PAD_INFO, data: padInfo },
                                { tableName: TableName.DOCUMENT_DATA, data: newClientVars },
                            ])];
                    case 15:
                        // 写入数据库
                        _b.sent();
                        return [2 /*return*/, new Result(undefined, {
                                retcode: 0,
                                data: updateResult.data,
                            })];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.generateCreateFileBody = function (createOptions, padInfo, offlineDatas) {
        var globalPadId = createOptions.globalPadId, docType = createOptions.docType, folderId = createOptions.folderId, withData = createOptions.withData;
        var atext;
        var apool;
        Log.info('generateCreateFileBody');
        if (offlineDatas.length > 0 && docType === FILE_TYPE.WORD) {
            var itemInit = offlineDatas[0];
            if (itemInit.type === OFFLINE_ITEM_TYPE.INIT) {
                var collab_client_vars = itemInit.data.collab_client_vars;
                Log.info('generateCreateFileBody before:', JSON.stringify(collab_client_vars));
                if (collab_client_vars.dver.startsWith('3.0.') && !collab_client_vars.initialAttributedText.text) {
                    collab_client_vars.initialAttributedText.text = docTextOfInitialAttributedText;
                }
                Log.info('generateCreateFileBody after:', JSON.stringify(collab_client_vars));
                atext = encodeURIComponent(JSON.stringify(__assign(__assign({}, collab_client_vars.initialAttributedText), { text: JSON.parse(unescape(collab_client_vars.initialAttributedText.text)) })));
                apool = JSON.stringify(collab_client_vars.apool);
            }
        }
        var maxCreateTime = Math.max.apply(Math, offlineDatas.map(function (item) { return item.createTime; }));
        var lastBrowseTime = Math.floor(maxCreateTime / 1000);
        var data;
        if (offlineDatas.length > 0) {
            var result = this.offlineDataSort(offlineDatas);
            var composedData = this.composeOfflineData(globalPadId, !withData ? [result[0]] : result);
            data = encodeURIComponent(JSON.stringify(composedData));
        }
        var finalFolderId = folderId || padInfo.folder || '/';
        Log.log('createFile folder_id:', finalFolderId);
        var createType = 11; // 离线创建文档
        var templateId = 0;
        var domainId = typeof globalPadId === 'string' ? globalPadId.split('$')[0] : '';
        var padId = typeof globalPadId === 'string' ? globalPadId.split('$')[1] : '';
        var version = '2.0.0'; // 初始版本从2.0.0开始
        return "create_type=" + createType + "&pad_id=" + padId + "&domain_id=" + domainId + "&doc_type=" + docType + "&templateId=" + templateId + "&xsrf=" + getXsrf() + "&version=" + version + "&folder_id=" + finalFolderId + "&title=" + padInfo.title + "&last_browse_ts=" + lastBrowseTime + (padInfo.isUserChangeTitle ? '&disable_auto_rename=1' : '') + (atext ? "&atext=" + atext : '') + (apool ? "&apool=" + apool : '') + (data ? "&data=" + data : '');
    };
    BaseBusinessHelper.prototype.updateOfflineDataBaseVersion = function (rev, globalPadId, clientVars) { };
    BaseBusinessHelper.prototype.updateClientVarsSocketInfo = function (globalPadId, currentClientVars) {
        return __awaiter(this, void 0, void 0, function () {
            var rev, subSheetId, secretId, preFetchResult, serverClientVars, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        rev = currentClientVars.collab_client_vars.rev;
                        subSheetId = currentClientVars.collab_client_vars.padSubId;
                        secretId = currentClientVars.collab_client_vars.client.upid;
                        return [4 /*yield*/, this.preFetchSingleSubBlockData(globalPadId, secretId, subSheetId, rev)];
                    case 1:
                        preFetchResult = _a.sent();
                        if (preFetchResult.error) {
                            return [2 /*return*/, preFetchResult];
                        }
                        serverClientVars = preFetchResult.data.data;
                        // 因为preFetchSingleSubBlockData接口返回的数据中没有secretId，所以这里要特殊处理下
                        currentClientVars.collab_client_vars.client = Object.assign(serverClientVars.collab_client_vars.client, { upid: secretId });
                        currentClientVars.collab_client_vars.pver = serverClientVars.collab_client_vars.pver;
                        currentClientVars.collab_client_vars.apid = serverClientVars.collab_client_vars.apid;
                        currentClientVars.collab_client_vars.wmode = serverClientVars.collab_client_vars.wmode;
                        currentClientVars.collab_client_vars.websocketReopenCount = serverClientVars.collab_client_vars.websocketReopenCount;
                        currentClientVars.collab_client_vars.pollingAttemptNumber = serverClientVars.collab_client_vars.pollingAttemptNumber;
                        // 需要更新userInfo
                        currentClientVars.userInfo = serverClientVars.userInfo;
                        return [2 /*return*/, new Result(undefined, currentClientVars)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, new Result(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.getPadInfo = function (id, docIdType) {
        if (docIdType === void 0) { docIdType = PadIdType.GLOBAL; }
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance()
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        switch (docIdType) {
                            case PadIdType.GLOBAL:
                                condition.addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, id);
                                break;
                            case PadIdType.SECRET:
                                condition.addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id);
                                break;
                        }
                        return [4 /*yield*/, this.database.get(TableName.PAD_INFO, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (!queryResult.error) {
                            return [2 /*return*/, queryResult.data];
                        }
                        Log.error(queryResult.error);
                        return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * 存储一个新建文档的信息
     * 分三步：
     * 1、创建padInfo
     * 2、构造documentData
     * 3、开启事务写入数据库
     * @param globalPadId
     * @param clientVars
     */
    BaseBusinessHelper.prototype.storeNewDocData = function (padType, folder, globalPadId, secretId, clientVars, isShareme) {
        var _a;
        if (isShareme === void 0) { isShareme = false; }
        return __awaiter(this, void 0, void 0, function () {
            var time, isManualOffline, isUserChangeTitle, padInfo, offlineData, documentStatus, updateResult;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        time = Date.now() / 1000;
                        isManualOffline = clientVars.isManualOffline, isUserChangeTitle = clientVars.isUserChangeTitle;
                        padInfo = this.generatorPadInfo({
                            globalPadId: globalPadId,
                            localPadId: clientVars.localPadId,
                            secretId: secretId,
                            padType: padType,
                            folder: folder,
                            dver: clientVars.collab_client_vars.dver,
                            initTitle: clientVars.padTitle,
                            time: time,
                            isShareme: isShareme,
                            isManualOffline: isManualOffline,
                            isUserChangeTitle: isUserChangeTitle > 0,
                            status: PadStatus.LOCAL,
                        });
                        padInfo.creator_domain = this.getDomainId(globalPadId);
                        offlineData = this.clientVars2OfflineData(globalPadId, clientVars, true);
                        offlineData.padStatus = PadStatus.LOCAL;
                        documentStatus = {
                            globalPadId: globalPadId,
                            secretId: secretId,
                            uid: padInfo.uid,
                            lastSyncTime: time,
                        };
                        return [4 /*yield*/, this.database.updateMultiTableData([
                                { tableName: TableName.PAD_INFO, data: padInfo },
                                { tableName: TableName.DOCUMENT_DATA, data: offlineData },
                                { tableName: TableName.DOCUMENT_STATUS, data: documentStatus },
                            ])];
                    case 1:
                        updateResult = _b.sent();
                        if (updateResult.error) {
                            Log.error('storeNewDocData 写入新文档数据发生异常', (_a = updateResult.error) === null || _a === void 0 ? void 0 : _a.stack);
                            return [2 /*return*/, updateResult];
                        }
                        return [2 /*return*/, updateResult];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.preCreateDoc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var condition, queryResult, documentIds, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance();
                        condition.addCondition('isCreated', QUERY_CONDITION_TYPE.ONLY, false);
                        return [4 /*yield*/, this.database.getAll(TableName.NEW_DOCUMENT_ID, condition)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error && !isNoResultError(queryResult.error)) {
                            return [2 /*return*/, queryResult];
                        }
                        documentIds = queryResult.data;
                        if (documentIds && documentIds.length > LocalNewMaxNum) {
                            return [2 /*return*/, this.preCreateDefaultClientVars(documentIds)];
                        }
                        return [4 /*yield*/, this.parent.preFetchDocIds()];
                    case 2:
                        result = _a.sent();
                        if (result.error) {
                            Log.error(result.error, '预拉异常');
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.preCreateDoc()];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.updatePreFetchIdInfo = function (documentId) {
        return __awaiter(this, void 0, void 0, function () {
            var condition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = new QueryCondition();
                        condition.addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, documentId.globalPadId);
                        return [4 /*yield*/, this.database.updateMultiTableData([
                                {
                                    tableName: TableName.NEW_DOCUMENT_ID,
                                    data: documentId,
                                },
                            ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.checkLocalClientVars = function () {
        return __awaiter(this, void 0, void 0, function () {
            var docType, condition, result, localNewDocResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        docType = [FILE_TYPE.WORD, FILE_TYPE.EXCEL, FILE_TYPE.SLIDE];
                        condition = QueryCondition.newInstance()
                            .addCondition('docType', QUERY_CONDITION_TYPE.IN, docType)
                            .addCondition('padStatus', QUERY_CONDITION_TYPE.ONLY, PadStatus.NEW)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.parent.user.getUserId());
                        result = new Result(undefined, { DocNum: 0, ExcelNum: 0, SlideNum: 0 });
                        return [4 /*yield*/, this.database.getAll(TableName.DOCUMENT_DATA, condition)];
                    case 1:
                        localNewDocResult = _a.sent();
                        if (localNewDocResult.error) {
                            Log.error(localNewDocResult.error, '读取本地预创建文档数据失败');
                            result.error = localNewDocResult.error;
                            return [2 /*return*/, result];
                        }
                        if (localNewDocResult && localNewDocResult.data) {
                            localNewDocResult.data.forEach(function (item) {
                                if (item.docType === FILE_TYPE.EXCEL) {
                                    result.data.ExcelNum = result.data.ExcelNum + 1;
                                }
                                else if (item.docType === FILE_TYPE.WORD) {
                                    result.data.DocNum = result.data.DocNum + 1;
                                }
                                else if (item.docType === FILE_TYPE.SLIDE) {
                                    result.data.SlideNum = result.data.SlideNum + 1;
                                }
                            });
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 更新文件夹的子文件key值
     */
    BaseBusinessHelper.prototype.updateFolderChildren = function (folderId, key) {
        var _a;
        if (folderId === void 0) { folderId = '/'; }
        return __awaiter(this, void 0, void 0, function () {
            var condition, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        condition = new QueryCondition();
                        condition.addCondition('key', QUERY_CONDITION_TYPE.IN, [this.parent.user.getUserId() + folderId]);
                        return [4 /*yield*/, this.database.get(TableName.FOLDER_INFO, condition)];
                    case 1:
                        result = _b.sent();
                        if (result.error) {
                            Log.error('updateFolderChildren() getPadInfo error。', (_a = result.error) === null || _a === void 0 ? void 0 : _a.stack);
                            return [2 /*return*/, new Result(new Error('GetPadInfoError'))];
                        }
                        if (!result.data.childrenKey) {
                            result.data.childrenKey = [];
                        }
                        result.data.childrenKey.push(key);
                        return [2 /*return*/, this.database.update(TableName.FOLDER_INFO, result.data)];
                }
            });
        });
    };
    /**
     * 获取domainid
     * @param id globalid
     */
    BaseBusinessHelper.prototype.getDomainId = function (id) {
        return id.split('$') && id.split('$').length ? id.split('$')[0] : '';
    };
    /**
     * 根据文档类型获取默认标题
     * @param padType 文档类型
     */
    BaseBusinessHelper.prototype.getDefaultInitTitle = function (padType) {
        var title = '无标题文档';
        switch (padType) {
            case FILE_TYPE.WORD:
                title = '无标题文档';
                break;
            case FILE_TYPE.EXCEL:
                title = '无标题表格';
                break;
            case FILE_TYPE.SLIDE:
                title = '无标题幻灯片';
                break;
        }
        return title;
    };
    /**
     * 根据options生成padInfo参数
     * @param options
     */
    BaseBusinessHelper.prototype.generatorPadInfo = function (options) {
        var globalPadId = options.globalPadId, secretId = options.secretId, localPadId = options.localPadId, padType = options.padType, folder = options.folder, dver = options.dver, _a = options.time, time = _a === void 0 ? Date.now() / 1000 : _a, _b = options.isShareme, isShareme = _b === void 0 ? false : _b, status = options.status, _c = options.isManualOffline, isManualOffline = _c === void 0 ? false : _c, _d = options.isUserChangeTitle, isUserChangeTitle = _d === void 0 ? false : _d;
        var defaultInfo = new PadInfo(this.parent.user);
        var key = this.parent.user.getUserId() + globalPadId;
        var domainId = this.getDomainId(globalPadId);
        var item = __assign(__assign({}, defaultInfo), { key: key, type: padType, uid: this.parent.user.getUserId(), globalPadId: globalPadId, domain_id: domainId, secretId: secretId, title: options.initTitle || this.getDefaultInitTitle(padType), pad_id: localPadId, status: status || PadStatus.NEW, creator: this.parent.user.getUserId(), create_ts: time, doc_type: padType, isMydoc: true, isMyCreated: true, isRencent: true, isShareme: isShareme === true, isOfflineCache: true, isManualOffline: isManualOffline,
            isUserChangeTitle: isUserChangeTitle,
            dver: dver, doc_type_desc: typeMap[padType], doc_url: "//docs.qq.com/" + typeMap[padType] + "/" + secretId, folder: folder, privilege: 0, last_modify_ts: time, last_browse_ts: time });
        return item;
    };
    /**
     *  列表页新建文档时，生成padinfo信息写到indexDB并且返回文档加密ID
     *
     * @protected
     * @param {FILE_TYPE} padType
     * @memberof BaseBusinessHelper
     */
    BaseBusinessHelper.prototype.createPadInfo = function (padType, folder, isShareme) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, result, documentId, dver, time, padInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = QueryCondition.newInstance();
                        // 从本地取已经创建好的文档id
                        condition.addCondition('isCreated', QUERY_CONDITION_TYPE.IN, [true]);
                        condition.addCondition('padType', QUERY_CONDITION_TYPE.ONLY, padType);
                        return [4 /*yield*/, this.database.get(TableName.NEW_DOCUMENT_ID, condition)];
                    case 1:
                        result = _a.sent();
                        if (!result.error) return [3 /*break*/, 6];
                        // 没有已经创建好的，就取任意id
                        condition = QueryCondition.newInstance();
                        condition.addCondition('isCreated', QUERY_CONDITION_TYPE.ONLY, false);
                        return [4 /*yield*/, this.database.get(TableName.NEW_DOCUMENT_ID, condition)];
                    case 2:
                        result = _a.sent();
                        if (!result.error) return [3 /*break*/, 5];
                        // 尝试执行一次预拉取
                        return [4 /*yield*/, this.preCreateDoc()];
                    case 3:
                        // 尝试执行一次预拉取
                        _a.sent();
                        condition = QueryCondition.newInstance();
                        // 从本地取已经创建好的文档id
                        condition.addCondition('isCreated', QUERY_CONDITION_TYPE.IN, [true]);
                        condition.addCondition('padType', QUERY_CONDITION_TYPE.ONLY, padType);
                        return [4 /*yield*/, this.database.get(TableName.NEW_DOCUMENT_ID, condition)];
                    case 4:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 5:
                        if (result.data) {
                            this.createDefaultClientVarsAndWriteDB(result.data);
                        }
                        _a.label = 6;
                    case 6:
                        // 校验下用户ID
                        if (!this.parent.user || !this.parent.user.getUserId()) {
                            return [2 /*return*/, new Result(new Error('UidError'))];
                        }
                        documentId = result.data;
                        if (!documentId) {
                            Log.error({ retcode: -1, reason: 'indexDB has not NewDocumentIds!' });
                            return [2 /*return*/, new Result(new Error('NoAvaliableIdError'))];
                        }
                        dver = this.getDverWithPadType(padType);
                        time = Date.now() / 1000;
                        padInfo = this.generatorPadInfo({
                            globalPadId: documentId.globalPadId,
                            secretId: documentId.secretId,
                            localPadId: documentId.localPadId,
                            padType: padType,
                            folder: folder,
                            dver: dver,
                            time: time,
                            isShareme: isShareme,
                        });
                        // 删除预分配的ID  先删除后写入  因为没有开事务  防止写入成功后没有删除成功，从而出现重复使用
                        condition = QueryCondition.newInstance().addCondition('globalPadId', QUERY_CONDITION_TYPE.ONLY, documentId.globalPadId);
                        return [4 /*yield*/, this.database.delete(TableName.NEW_DOCUMENT_ID, condition)];
                    case 7:
                        _a.sent();
                        // 写入新的PadInfo
                        return [4 /*yield*/, this.database.set(TableName.PAD_INFO, padInfo)];
                    case 8:
                        // 写入新的PadInfo
                        _a.sent();
                        return [4 /*yield*/, this.updateFolderChildren(folder, padInfo.key)];
                    case 9:
                        _a.sent();
                        // 创建文档成功的时候异步执行一次预创建，防止本地数量不足
                        this.preCreateDoc();
                        return [2 /*return*/, new Result(undefined, padInfo)];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.createPadInfoFromClientVars = function (clientVars) {
        return __awaiter(this, void 0, void 0, function () {
            var globalPadId, padInfo, updatePadInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        globalPadId = clientVars.globalPadId;
                        return [4 /*yield*/, this.getPadInfo(globalPadId)];
                    case 1:
                        padInfo = _a.sent();
                        if (!padInfo) {
                            updatePadInfo = this.buildPadInfo(clientVars);
                            if (updatePadInfo) {
                                Log.log('更新padInfo：', updatePadInfo);
                                this.database.set(TableName.PAD_INFO, updatePadInfo);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseBusinessHelper.prototype.getManualPadInfo = function (secretId) {
        return __awaiter(this, void 0, void 0, function () {
            var uid, condition, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uid = this.parent.user.getUserId();
                        condition = QueryCondition.newInstance()
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, uid)
                            .addCondition('isManualOffline', QUERY_CONDITION_TYPE.ONLY, true)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, secretId);
                        return [4 /*yield*/, this.database.get(TableName.PAD_INFO, condition)];
                    case 1:
                        result = _a.sent();
                        if (result.error) {
                            Log.error('查询失败', result.error);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 设置业务的默认代码版本号  在创建文档的时候会用到。
     * @param type
     * @param version
     */
    BaseBusinessHelper.prototype.setDefaultCodeVersion = function (type, version) {
        this.defaultCodeVersion.set(type, version);
        localStorage.setItem(type + "_code_version", version);
    };
    /**
     * 根据业务类型获取代码版本号
     * @param type
     */
    BaseBusinessHelper.prototype.getCodeVersion = function (type) {
        return this.defaultCodeVersion.get(type) || localStorage.getItem(type + "_code_version") || ''; // 如果没有这个类型那就1.0.0吧
    };
    BaseBusinessHelper.prototype.getDverWithPadType = function (padType) {
        if (padType === FILE_TYPE.EXCEL) {
            return this.getCodeVersion('sheet');
        }
        if (padType === FILE_TYPE.WORD) {
            return this.getCodeVersion('doc');
        }
        if (padType === FILE_TYPE.SLIDE) {
            return this.getCodeVersion('slide');
        }
    };
    BaseBusinessHelper.prototype.getTypeStringWithPadType = function (padType) {
        if (padType === FILE_TYPE.EXCEL) {
            return 'sheet';
        }
        if (padType === FILE_TYPE.WORD) {
            return 'word';
        }
        if (padType === FILE_TYPE.SLIDE) {
            return 'slide';
        }
    };
    return BaseBusinessHelper;
}());
export { BaseBusinessHelper };
//# sourceMappingURL=BaseBusinessHelper.js.map